import type {
  GenerateOutlineRequest,
  GenerateOutlineWizardPayload,
} from "../types/generation";

export const buildOutlineRequest = (i: {
  prompt: string;
  docType: string;
  tone: string;
  length: string;
  language: string;
  brandDomain: string | null;
  companyName: string | null;
  fileUrl: string | null;
  fileName: string | null;
  fileType: string | null;
  /**
   * The template's own slides, described — set only when the user picked a
   * template. See ./template-outline-seed, and the block that reads it in
   * dotell-backend wizard/template-slides-prompt.js.
   */
  templateSlides?: string | null;
}): GenerateOutlineRequest => {
  const wizardPayload: GenerateOutlineWizardPayload = {};

  if (i.prompt) wizardPayload["presentation description"] = i.prompt;
  if (i.tone) wizardPayload.style = i.tone;
  if (i.length) wizardPayload["slide length"] = i.length;
  if (i.language) wizardPayload.language = i.language;
  if (i.docType) {
    wizardPayload["wizard doc subtype"] = i.docType;
    wizardPayload["wizard doc category"] = i.docType;
  }
  if (i.brandDomain) wizardPayload.website = i.brandDomain;
  if (i.companyName) wizardPayload["company name"] = i.companyName;
  if (i.fileUrl) wizardPayload["file url"] = i.fileUrl;
  if (i.fileName) wizardPayload["file name"] = i.fileName;
  if (i.fileType) wizardPayload["file type"] = i.fileType;
  if (i.templateSlides) wizardPayload["template slides"] = i.templateSlides;

  return { wizardPayload };
};
